export const CatUpIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Barcode lines */}
      <rect x="2" y="4" width="2" height="12" rx="0.5" fill="currentColor" />
      <rect x="5.5" y="4" width="1" height="12" rx="0.5" fill="currentColor" />
      <rect x="8" y="4" width="2" height="12" rx="0.5" fill="currentColor" />
      <rect x="11.5" y="4" width="1" height="12" rx="0.5" fill="currentColor" />
      <rect x="14" y="4" width="1.5" height="12" rx="0.5" fill="currentColor" />
      <rect x="17" y="4" width="2" height="12" rx="0.5" fill="currentColor" />
      <rect x="20.5" y="4" width="1" height="12" rx="0.5" fill="currentColor" />
      {/* Upload arrow */}
      <path
        d="M12 22v-5m0 0l-2.5 2.5M12 17l2.5 2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
